import Model from './BaseModel';

export default class MultiExpressGroupParentMarket extends Model {
	resourceName() {
		return 'multi_express_group_parent_market';
	}

	fields() {
		return ['multi_express_group_id', 'parent_market', 'order'];
	}
}
